import { createAction } from 'redux-actions-helpers'

export const createCourse = createAction(
  '@@admin-create-course/CREATE_COURSE',
  (
    title: string,
    status: string,
    starts_at: string,
    auto_subscription: boolean
  ): any => ({
    title,
    status,
    starts_at,
    auto_subscription,
  })
)

export const createCourseSuccess = createAction(
  '@@admin-create-course/CREATE_COURSE_SUCCESS'
)

export const createCourseFailure = createAction(
  '@@admin-create-course/CREATE_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-create-course/DESTROY')
